
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 19","data-token-name":"normal-text"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.18 15H7.855L2.393 6.612h-.055c.073.985.11 1.887.11 2.707V15H1.373V5.006h1.313l5.448 8.353h.054a76.22 76.22 0 01-.061-1.182 20.699 20.699 0 01-.034-1.436V5.006H9.18V15zm5.19 0h-.997V7.318H10.66v-.884h6.422v.884h-2.713V15z","fill":"currentColor"}})])
          )
        }
      }
    